import { render, staticRenderFns } from "./SettingsBotsList.vue?vue&type=template&id=d359a050&scoped=true&"
import script from "./SettingsBotsList.vue?vue&type=script&lang=js&"
export * from "./SettingsBotsList.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBotsList.vue?vue&type=style&index=0&id=d359a050&scoped=true&lang=scss&"
import style1 from "./SettingsBotsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d359a050",
  null
  
)

export default component.exports